import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 14.423q.271 0 .443-.172q.173-.172.173-.443q0-.272-.173-.444q-.172-.172-.443-.172t-.443.172t-.173.444t.173.443t.443.172m-.5-2.961h1V5.385h-1zM3 20.077V4.616q0-.691.463-1.153T4.615 3h14.77q.69 0 1.152.463T21 4.616v10.769q0 .69-.463 1.153T19.385 17H6.077zM5.65 16h13.735q.23 0 .423-.192t.192-.423V4.615q0-.23-.192-.423T19.385 4H4.615q-.23 0-.423.192T4 4.615v13.03zM4 16V4z"
        fill="#637381"
        stroke="#637381"
        strokeWidth={0.5}
      />
    </svg>
  )
}

export default SvgComponent
